module.exports = __webpack_public_path__ + "static/media/ft1-drunk.8458c7e4.png";